import React, { useState } from 'react';
import { Row, Col, InputGroup, Button, Form } from 'react-bootstrap';

const FilterComponent = ({
  filterCustomer,
  onFilterCustomer,
  filterPLC,
  onFilterPLC,
  filterCNC,
  onFilterCNC,
  filterTulus,
  onFilterTulus,
  filterIOT,
  onFilterIOT,
  filterTOB,
  onFilterTOB,
  optionsPLC,
  optionsCNC,
  optionsTulus,
  optionsIOT,
  optionsTOB,
  onClearCustomer,
  onClearPLC,
  onClearCNC,
  onClearTulus,
  onClearIOT,
  onClearTOB
}) => {

  const [showFilter, setShowFilter] = useState(false);

  const inputStyle = { fontSize: '12px', padding: '4px 6px', height: '28px' }; // font e altezza ridotti
  const buttonStyle = { fontSize: '12px', padding: '4px 8px', marginLeft: '4px' }; // bottone compatto

  return (
    <>
      <Row className="mt-3 mb-3" style={{ padding: 0 }}>
        <Col style={{ padding: 0 }}>
          <Button
            style={{ float: 'right', fontSize: '18px', padding: '4px 8px' }}
            onClick={() => setShowFilter(!showFilter)}
          >
            {showFilter ? "Chiudi Gestione Filtro" : "Apri Gestione Filtro"}
          </Button>
        </Col>
      </Row>

      {showFilter && (
        <Row className="text-center mt-2 mb-2">
          {[{
            value: filterCustomer, onChange: onFilterCustomer, onClear: onClearCustomer, placeholder: "Filter By Customer Name", options: null
          }, {
            value: filterPLC, onChange: onFilterPLC, onClear: onClearPLC, placeholder: "Filter By PLC version", options: optionsPLC
          }, {
            value: filterCNC, onChange: onFilterCNC, onClear: onClearCNC, placeholder: "Filter By CNC version", options: optionsCNC
          }, {
            value: filterTulus, onChange: onFilterTulus, onClear: onClearTulus, placeholder: "Filter By Tulus version", options: optionsTulus
          }, {
            value: filterIOT, onChange: onFilterIOT, onClear: onClearIOT, placeholder: "Filter By IOT version", options: optionsIOT
          }, {
            value: filterTOB, onChange: onFilterTOB, onClear: onClearTOB, placeholder: "Filter By TOB version", options: optionsTOB
          }].map((filter, idx) => (
            <Col md={4} key={idx}>
              <InputGroup className="mb-2">
                {filter.options ? (
                  <Form.Control
                    as="select"
                    value={filter.value}
                    onChange={filter.onChange}
                    style={inputStyle}
                  >
                    <option value="">{filter.placeholder}</option>
                    {filter.options.sort().map(option => (
                      <option key={option} value={option}>{option}</option>
                    ))}
                  </Form.Control>
                ) : (
                  <Form.Control
                    type="text"
                    placeholder={filter.placeholder}
                    value={filter.value}
                    onChange={filter.onChange}
                    style={inputStyle}
                  />
                )}
                <Button type="button" onClick={filter.onClear} style={buttonStyle}>X</Button>
              </InputGroup>
            </Col>
          ))}
        </Row>
      )}
    </>
  );
};

export default FilterComponent;
